import React from "react";
import { Card, Tag } from "antd";
import CustomTypography from "../../../commonComponents/CustomTypography";

const GotoDetailsHeader = ({
  title,
  subtitle,
  subtitleLabel,
  status,
  // For complex subtitle (PhoneNumber use case)
  assignedTo,
  assignedToRole,
  assignedToLabel = "Currently assigned to:",
}) => {
  const getStatusColor = status => {
    if (status === "Active") return "blue";
    if (status === "Invite sent") return "gold";
    if (status === "Inactive") return "red";
    return "default";
  };

  const renderSubtitle = () => {
    // Complex assignedTo rendering (for PhoneNumber)
    if (assignedTo !== undefined) {
      return (
        <div>
          <span className="text-[#000000A6]">{assignedToLabel} </span>
          {assignedTo ? (
            <>
              <CustomTypography variant="text" strong className="!text-black !inline">
                {assignedTo}
              </CustomTypography>
              {assignedToRole && (
                <CustomTypography variant="text" className="text-[#000000A6] !inline">
                  {" "}
                  ({assignedToRole})
                </CustomTypography>
              )}
            </>
          ) : (
            <span className="text-[#000000A6]">--</span>
          )}
        </div>
      );
    }

    // Simple subtitle with label
    if (subtitleLabel && subtitle !== undefined) {
      return (
        <CustomTypography variant="text" className="text-[#000000A6]">
          {subtitleLabel}: {subtitle || "N/A"}
        </CustomTypography>
      );
    }

    return null;
  };

  return (
    <Card className="bg-[#f5f5f5]" styles={{ body: { padding: "20px 24px", borderRadius: "8px" } }}>
      <div className="flex justify-between items-start mb-2">
        <CustomTypography.Heading4 className="!mb-0">{title || "--"}</CustomTypography.Heading4>
        {status && (
          <div className="flex items-center gap-2">
            <Tag color={getStatusColor(status)}>{status}</Tag>
          </div>
        )}
      </div>
      {renderSubtitle()}
    </Card>
  );
};

export default GotoDetailsHeader;
